export default "__VITE_ASSET__CV1rWy0a__"